import template from '../working.with/working.with.html';
import { WorkingWithCtrl } from './working.with.controller';

export const workingWith: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: WorkingWithCtrl,
  controllerAs: 'wWvm',
  restrict: 'EA',
  template,
  replace: true,
});
